/* eslint-disable class-methods-use-this, no-console, prefer-destructuring, no-use-before-define, no-shadow */
const Header = () => {
	const header = document.getElementById("header-desktop");
	const headerMobile = document.getElementById("header-mobile");
	const headerHeight = header.offsetHeight - 50;
	let distanceToTop = document.documentElement.scrollTop;
	const headerMobileOpenLevel = headerMobile.querySelectorAll(
		".header-mobile__open-level"
	);
	const headerMobileCloseLevel = headerMobile.querySelectorAll(
		".header-mobile__close-level"
	);

	headerMobileOpenLevel.forEach((headerMobileOpenLevelItem) => {
		headerMobileOpenLevelItem.addEventListener("click", hideFirstLevel(event));
	});

	headerMobileCloseLevel.forEach((headerMobileCloseLevelItem) => {
		headerMobileCloseLevelItem.addEventListener("click", showFirstLevel(event));
	});
	
	function hideFirstLevel(e) {
		//console.log(e);
		if (
			headerMobile.classList.contains("header-mobile--hide-first-level") ===
			false
		) {
			headerMobile.classList.add("header-mobile--hide-first-level");
		}
	}

	function showFirstLevel(e) {
		//console.log(e);
		if (headerMobile.classList.contains("header-mobile--hide-first-level")) {
			headerMobile.classList.remove("header-mobile--hide-first-level");
		}
	}

	const throttle = (callback, wait = 100) => {
		let timer = null;

		return (args) => {
			if (timer === null) {
				timer = setTimeout(() => {
					callback.apply(this, args);
					timer = null;
				}, wait);
			}
		};
	};

	const callback = () => {
		const newDistanceToTop = document.documentElement.scrollTop;
		const headerMobile = document.querySelector(
			"#header-mobile div:first-of-type"
		);

		const mdSize = window.matchMedia("(max-width: 768px)");

		if (window.getComputedStyle(headerMobile).display !== "block") {
			if (mdSize.matches) {
				if (newDistanceToTop <= headerHeight) {
					header.classList.remove("scrolled", "scrolled--show", "fixed");
				} else if (
					newDistanceToTop < distanceToTop &&
					newDistanceToTop > headerHeight
				) {
					header.classList.add("scrolled--show");
				} else {
					header.classList.add("scrolled");
					header.classList.remove("scrolled--show");
				}
				distanceToTop = newDistanceToTop;
			} else {
				if (
					newDistanceToTop >= headerHeight &&
					!header.classList.contains("scrolled--show")
				) {
					header.classList.add("scrolled--show");
				}
				distanceToTop = newDistanceToTop;
			}
		}
	};

	// Scroll event listener
	const mdSize = window.matchMedia("(max-width: 768px)");

	if (mdSize.matches) {
		window.addEventListener("scroll", throttle(callback, 200));

		if (distanceToTop > 0) {
			header.classList.add("scrolled");
		}
	} else {
		window.addEventListener("scroll", callback);
	}
};

export default Header;
